import { Container, Navbar, Dropdown, Modal, Button } from "react-bootstrap"
import Logo from "../../assets/images/ic_tutorial_logo.svg";
import avtar from '../../assets/images/avtar-male.png'
import { GoChevronDown } from "react-icons/go";
import { AiOutlineLogout } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProfileDropdown from "./ProfileDropdown";
const Header = () => {
    const navigate = useNavigate();
    const [deleteModal, setDeleteModal] = useState(false);
    const [profile_image, setProfileImage] = useState<any>(null);
    // const profile_image_url = useSelector((state: any) => state?.profile?.profile_setting?.file);
    const profile_image_url = useSelector((state: any) => state?.profile?.profile_setting);
    const [showDropdown, setShowDropdown] = useState(false);

    const handleLogout = () => {
        localStorage.clear();
        setDeleteModal(false);
        navigate("/login");
    }

    useEffect(() => {
        if (profile_image_url !== null || profile_image_url !== undefined) {
            setProfileImage(profile_image_url);
        }
    }, [profile_image_url]);

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar expand="lg">
                        <Navbar.Brand className="d-flex gap-2 align-items-center">
                            <div style={{ backgroundColor: "#8DF1FF" }}>
                                <img src={Logo} width="80" height={50} alt="Logo" />
                            </div>
                            <div>KUP Fantasy Sport</div>
                        </Navbar.Brand>
                        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                        <div className="d-flex align-items-center ms-auto gap-3" >
                            <Dropdown className="profile-dd"
                                show={showDropdown}
                                onToggle={() => setShowDropdown(!showDropdown)}
                            >
                                <Dropdown.Toggle onClick={() => setShowDropdown(!showDropdown)}>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <img src={profile_image} width={32} height={32} className=" rounded-circle object-fit-cover" alt='' />
                                    </div>
                                    <GoChevronDown size={16} className='icon' />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                    <ProfileDropdown closeDropdown={() => setShowDropdown(false)} />

                                    {/* <span className="dropdown-item" onClick={() => setDeleteModal(true)} style={{ cursor: "pointer" }}> */}
                                    {/* <AiOutlineLogout size={18} className="me-2" /> Logout */}
                                    {/* </span> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Navbar>
                </Container>
            </header>


            <Modal
                show={deleteModal}
                onHide={() => {
                    setDeleteModal(false);
                }}
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title> <h5>Logout</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-18">
                    <div className="text-center pt-3">
                        <h2 className="font-16 font-medium pb-3">{("Are you sure you want to logout?")}</h2>
                        <div className="text-end mobile-sticky-bottom text-center">
                            <Button
                                className="btn-outline-brand me-3"
                                id="no"
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                No
                            </Button>
                            <Button
                                className="btn-outline-brand me-3"
                                id="yes"
                                onClick={handleLogout}
                            >
                                Yes
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default Header;